import { useAuth } from '@practium/features/auth';
import { useGetMe } from '@practium/features/api';
import { SupportPage } from './SupportPage';

export const SupportPageClient = () => {
	const { user } = useAuth();
	const { data: me } = useGetMe();
	const avatarUrl = me?.avatar?.url || undefined;
	return <SupportPage userName={user?.name || 'Usuário'} avatarUrl={avatarUrl} />;
};
